//////LIBRARY//////
import React from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'
//////ASSETS//////
import gazBtl from '../../assets/images/home/gaz-bottle.png'

//////STYLED//////
const HomeWrapper = styled.div``
const LogoHomePageWapper = styled.div`
	width: 100%;
	height: auto;
	background-color: #fff;
	border-radius: 3px;
	text-align: center;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	margin: auto;
	margin-bottom: 15px;
	/* $visible : prop transitoire, jamais transmise au DOM, contrairement au nom visibility
	   qui est un attribut valide et faisait rejeter le booleen false par React. */
	visibility: ${(props) => (props.$visible ? 'initial' : 'hidden')};
`
const LogoHomePage = styled.img`
	max-height: 220px;
	max-width: 472px;
`
const Welcome = styled.div`
	text-align: center;
	color: ${(props) => props.theme.colors.primary};
	font-size: ${(props) => props.theme.font.fxxxxl};
	font-weight: bold;
`
const UseForStart = styled.div`
	text-align: center;
	margin-top: 15px;
	font-size: ${(props) => props.theme.font.fxl};
	letter-spacing: 0.1rem;
`
const GazBtlWrapper = styled.div`
	height: auto;
	width: 100%;
	text-align: center;
`
const GazBtl = styled.img`
	height: 400px;
	width: 350px;
	border-radius: 15px;
	margin-top: 30px;
`
//////STYLED//////

const Home = (props) => {
	const { user, firstName, translations } = useSelector(
		(state) => ({
			firstName: state.user.identity.firstName,
			translations: state.languages.translations,
			user: state.user,
		}),
		shallowEqual
	)

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<HomeWrapper>
			<LogoHomePageWapper $visible={user.identity.company.logoFileName?.length > 0}>
				<LogoHomePage src={`/${user.identity.company.logoFileName}`} />
			</LogoHomePageWapper>
			<Welcome>
				{translations['common__message__welcome'] + ','} {firstName} !
			</Welcome>
			<UseForStart>{translations['common__message__verticalMenu_use']}</UseForStart>
			<GazBtlWrapper>
				<GazBtl src={gazBtl} />
			</GazBtlWrapper>
		</HomeWrapper>
	)
}

Home.propTypes = {}

Home.defaultPropTypes = {}

export default Home
